import { PlusOutlined } from "@ant-design/icons";
import Button from "@/components/common/Button";
import PropTypes from "prop-types";

const ProceedButtons = ({ activeTab, handleOpenModal }) => {
  return (
    <div>
      {activeTab === "kyc" && (
        <Button
          text="Update Info"
          customBgColor="primary"
          customTextColor="white"
          className="w-[130px] h-[37px] text-small-xs whitespace-nowrap hidden lg:flex"
        />
      )}
      {activeTab === "security" && (
        <Button
          text="ADD NEW QUESTION"
          icon={<PlusOutlined className="ml-3 text-primary" />}
          iconPosition="left"
          customBgColor="white"
          customTextColor="primary"
          className="border text-[10px] border-primary w-[200px] h-[36px] hidden lg:flex"
          onClick={handleOpenModal}
        />
      )}
    </div>
  );
};

ProceedButtons.propTypes = {
  activeTab: PropTypes.string,
  handleOpenModal: PropTypes.func,
};

export default ProceedButtons;
